<p-card>
    <p-tabMenu [model]="tabs" />
    <router-outlet class="mt-3"></router-outlet>
</p-card>
